import script from "./infoChange.vue?vue&type=script&setup=true&lang=js"
export * from "./infoChange.vue?vue&type=script&setup=true&lang=js"

import "./infoChange.vue?vue&type=style&index=0&id=83554892&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83554892"]])

export default __exports__